import { API_ENDPOINTS } from "config/config";
import { buildCanonicalQueryParams } from "utils/dateRangeParams";

const get = async (api, endpoint, params = {}) => {
  const response = await api.get(endpoint, {
    params: buildCanonicalQueryParams(params),
  });
  return response.data.data;
};

export const buildTruthQueryParams = buildCanonicalQueryParams;

export const getOverview = (api, params) =>
  get(api, API_ENDPOINTS.ANALYTICS_TRUTH_OVERVIEW, params);

export const getFinanceKpis = (api, params) =>
  get(api, API_ENDPOINTS.ANALYTICS_TRUTH_FINANCE_KPIS, params);

export const getSalesCount = (api, params) =>
  get(api, API_ENDPOINTS.ANALYTICS_TRUTH_SALES_COUNT, params);

export const getRevenue = (api, params) =>
  get(api, API_ENDPOINTS.ANALYTICS_TRUTH_REVENUE, params);

export const getMrr = (api, params) =>
  get(api, API_ENDPOINTS.ANALYTICS_TRUTH_MRR, params);

export const getFunnelMetrics = (api, params) =>
  get(api, API_ENDPOINTS.ANALYTICS_TRUTH_FUNNEL_METRICS, params);

export const getConsistencyReport = (api, params) =>
  get(api, API_ENDPOINTS.ANALYTICS_TRUTH_CONSISTENCY_REPORT, params);
